// extracted by mini-css-extract-plugin
module.exports = {"body":"Accordion_body__MWW8O"};